<template>
	<v-row v-if="!loading" class="ma-0 pb-offset">
		<v-col class="pa-0">

			<show v-if="models.compliancecompetence" :id="id" :models="models" :infos="infos" topClass=""></show>

			<!-- Competenza & Formazione -->
			<v-card v-if="competence" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Competenza & Formazione</p>
					<v-spacer></v-spacer>
					<v-chip :color="statusColor(competence.status)" dark small label>{{ competence.compliance_competence_status_text || competence.status }}</v-chip>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<v-row dense class="mb-2">
						<v-col cols="12" md="6"><div class="grey--text">Persona</div><div class="text-subtitle-1">{{ competence.person || '–' }}</div></v-col>
						<v-col cols="12" md="6"><div class="grey--text">Ruolo / mansione</div><div class="text-subtitle-1">{{ competence.role || '–' }}</div></v-col>
					</v-row>
					<v-row dense class="mb-2">
						<v-col cols="12" md="6"><div class="grey--text">Competenza richiesta</div><div class="text-body-2" style="white-space: pre-line">{{ competence.required_competence || '–' }}</div></v-col>
						<v-col cols="12" md="6"><div class="grey--text">Esigenze formative</div><div class="text-body-2" style="white-space: pre-line">{{ competence.training_needs || '–' }}</div></v-col>
					</v-row>
					<v-row dense>
						<v-col cols="12" md="6"><div class="grey--text">Ultima formazione</div><div class="text-subtitle-1">{{ competence.last_training_date || '–' }}</div></v-col>
						<v-col cols="12" md="6">
							<div class="grey--text">Scadenza</div>
							<div class="text-subtitle-1" :class="{ 'red--text font-weight-bold': isExpired }">
								{{ competence.expiry_date || '–' }}
								<v-icon v-if="isExpired" color="red" small>mdi-alert</v-icon>
							</div>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>

			<!-- Norme -->
			<v-card v-if="competence" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Norme</p>
					<v-spacer></v-spacer>
					<v-btn text color="primary" small @click="openNorms"><v-icon left small>mdi-pencil</v-icon> Modifica</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<template v-if="competence.norms && competence.norms.length">
						<v-chip v-for="n in competence.norms" :key="n.value" :color="n.color || 'primary'" dark small class="mr-1" label>{{ n.text }}</v-chip>
					</template>
					<span v-else class="grey--text">— nessuna —</span>
				</v-card-text>
			</v-card>

			<dms-uploader class="mt-4" :id="id" attachable-type="compliancecompetence"></dms-uploader>

			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip }">
					<v-fab-transition>
						<v-btn v-on="{ ...tooltip }" @click.native="$eventBusUtility.goTo($router, 'compliancecompetences-edit', id)" color="primary" dark fixed bottom right fab>
							<v-icon>edit</v-icon>
						</v-btn>
					</v-fab-transition>
				</template>
				<span>Modifica</span>
			</v-tooltip>

			<v-dialog v-model="normsDialog" max-width="560" persistent>
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3"><p class="pl-2 pl-xl-3 mb-0">Norme applicabili</p></v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-autocomplete v-model="formNorms" :items="normOptions" item-text="text" item-value="value"
							label="Norme" outlined dense :menu-props="{'offset-y': true}" multiple chips small-chips deletable-chips prepend-icon="mdi-certificate"></v-autocomplete>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="pa-3">
						<v-spacer></v-spacer>
						<v-btn text color="info" @click="normsDialog = false">Annulla</v-btn>
						<v-btn text color="primary" :loading="savingNorms" @click="saveNorms">Salva</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'ComplianceCompetence',
	props: { id: Number },
	data() {
		return {
			loading: true,
			models: {},
			infos: {},
			normsDialog: false,
			savingNorms: false,
			formNorms: [],
			normOptions: []
		}
	},
	computed: {
		competence() { return this.models.compliancecompetence },
		isExpired() {
			if (!this.competence || !this.competence.expiry_date) return false
			return new Date(this.competence.expiry_date) < new Date(new Date().toISOString().slice(0, 10))
		}
	},
	created() { this.load() },
	methods: {
		load() {
			this.loading = true
			this.axios.get('compliancecompetences/' + this.id).then(r => {
				this.models = r.data.models
				this.infos = r.data.infos
				this.loading = false
			}, () => { this.loading = false; this.$store.commit('setSnackbarError') })
		},
		statusColor(s) {
			return { adeguata: 'success', da_sviluppare: 'orange', critica: 'red', da_valutare: 'grey' }[s] || 'grey'
		},
		openNorms() {
			this.formNorms = (this.competence.norms || []).map(n => n.value)
			if (!this.normOptions.length) this.axios.get('compliance-norms-options').then(r => { this.normOptions = r.data.data })
			this.normsDialog = true
		},
		saveNorms() {
			this.savingNorms = true
			this.axios.put('compliancecompetences/' + this.id, { norms: this.formNorms }).then(() => {
				this.savingNorms = false; this.normsDialog = false
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Salvato', timeout: 4000 })
				this.load()
			}, () => { this.savingNorms = false; this.$store.commit('setSnackbarError') })
		}
	}
}
</script>
